import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Heading2 } from '@blueprint/ui';

export const Wrapper = styled.div(
    ({ theme: { mq } }) =>
        css`
            width: 100%;
            display: flex;
            flex-direction: column;

            ${mq.medium} {
                margin-right: 0;
                flex-direction: row-reverse;
                max-width: 100%;
                align-items: flex-start;
            }
        `
);

export const Image = styled.img(
    ({ theme: { mq, borderRadius } }) =>
        css`
            display: flex;
            max-width: 100%;
            width: 100%;
            height: auto;
            border-radius: ${borderRadius['8px']};

            ${mq.medium} {
                width: 55%;
            }
        `
);

export const MainContent = styled.div(
    ({ theme: { mq, spacing } }) =>
        css`
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: ${spacing['16px']} 0 ${spacing['24px']} 0;

            ${mq.medium} {
                margin-right: ${spacing['24px']};
                padding-top: 0;
            }

            ${mq.large} {
                padding: ${spacing['24px']} 0;
                width: 50%;
                margin-right: 80px;
            }
        `
);

export const Heading = styled(Heading2)(
    ({ theme: { spacing, mq } }) =>
        css`
            margin-bottom: ${spacing['8px']};

            ${mq.large} {
                font-size: ${spacing['32px']};
            }
        `
);

export const Description = styled('p')(
    ({ theme: { spacing, mq, type, colors } }) =>
        css`
            margin: 0 0 ${spacing['24px']} 0;
            line-height: ${type.lineHeight};
            font-size: ${type.body};
            color: ${colors['text-body']};

            ${mq.medium} {
                margin-bottom: ${spacing['16px']};
            }

            ${mq.large} {
                margin-bottom: ${spacing['24px']};
                max-width: 500px;
                font-size: 1.125rem;
            }
        `
);
